import { BO, BusinessObjectBase, Weaver } from '@skylab-shared/core';
import { KsefSendParametersModel } from '@skylab-shared/dataModel';

@BO({ modelType: KsefSendParametersModel })
export class KsefSendParametersBO extends BusinessObjectBase<KsefSendParametersModel> {
	public constructor(
		weaver: Weaver
	) {
		super(weaver);
	}
}
